export default {
  // Home page, basic <title> and <description>
  appName: 'Zocial',
  appDescription: 'Un cliente web minimalista para Mastodon que hace las cosas a su manera.',
  homeDescription: `
    <p>
      Un cliente web minimalista para Mastodon que hace las cosas a su manera.
    </p>`,
  homeMultiInstance: `
    <p>
      Inicia sesión en una instancia para empezar:
    </p>`,
  logIn: 'Iniciar sesión',
  footer: `
    <p>
      Powered by <a rel="noopener" target="_blank" href="https://ztfr.eu">Zeitfresser</a> · <a href="/settings/about#donations" rel="prefetch">Donations</a> · <a href="/settings/about#privacy-policy" rel="prefetch">Privacy Policy</a> · <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/releases">Zocial v{version}</a>
    </p>
  `,
  // Manifest
  newStatus: 'Nuevo toot',
  // Generic UI
  loading: 'Cargando',
  okay: 'OK',
  cancel: 'Cancelar',
  alert: 'Alerta',
  close: 'Cerrar',
  account: 'Cuenta',
  start: 'Comenzar',
  stop: 'Detener',
  error: 'Error: {error}',
  errorShort: 'Error:',
  // Relative timestamps
  justNow: 'ahora mismo',
  // Navigation, page titles
  navItemLabel: `
    {label} {selected, select,
      true {(página actual)}
      other {}
    } {name, select,
      notifications {{count, plural,
        =0 {}
        one {(1 notificación)}
        other {({count} notificaciones)}
      }}
      community {{count, plural,
        =0 {}
        one {(1 solicitud de seguimiento)}
        other {({count} solicitudes de seguimiento)}
      }}
      other {}
    }
  `,
  blockedUsers: 'Usuarios bloqueados',
  bookmarks: 'Marcadores',
  directMessages: 'Mensajes directos',
  favorites: 'Favoritos',
  reactions: 'Reacciones',
  bubble: 'Burbuja',
  federated: 'Federada',
  home: 'Inicio',
  local: 'Local',
  notifications: 'Notificaciones',
  mutedUsers: 'Usuarios silenciados',
  pinnedStatuses: 'Toots fijados',
  followRequests: 'Solicitudes de seguimiento',
  followRequestsLabel: `Solicitudes de seguimiento {hasFollowRequests, select,
    true {({count})}
    other {}
  }`,
  list: 'Lista',
  search: 'Buscar',
  pageHeader: 'Encabezado de página',
  goBack: 'Retroceder',
  back: 'Atrás',
  profile: 'Perfil',
  federatedTimeline: 'Cronología federada',
  bubbleTimeline: 'Cronología de burbujas',
  localTimeline: 'Cronología local',
  // community page
  community: 'Comunidad',
  pinnableTimelines: 'Cronologías que puedes fijar',
  timelines: 'Cronologías',
  lists: 'Listas',
  instanceSettings: 'Opciones para instancia',
  notificationMentions: 'Notificación de menciones',
  profileWithMedia: 'Perfil con multimedia',
  profileWithReplies: 'Perfil con respuestas',
  hashtag: 'Hashtag',
  // not logged in
  profileNotLoggedIn: 'Aquí se mostrará una cronología de usuario cuando hayas iniciado sesión.',
  bookmarksNotLoggedIn: 'Tus marcadores se mostrarán aquí cuando hayas iniciado sesión.',
  directMessagesNotLoggedIn: 'Tus mensajes directos se mostrarán aquí cuando hayas iniciado sesión.',
  favoritesNotLoggedIn: 'Tus favoritos se mostrarán aquí cuando hayas iniciado sesión.',
  federatedTimelineNotLoggedIn: 'Tu cronología federada se mostrará aquí cuando hayas iniciado sesión.',
  localTimelineNotLoggedIn: 'Tu cronología localse mostrará aquí cuando hayas iniciado sesión.',
  searchNotLoggedIn: 'Puedes buscar una vez que inicias sesión en una instancia.',
  communityNotLoggedIn: 'Las opciones para comunidad se mostrarán aquí cuando hayas iniciado sesión.',
  listNotLoggedIn: 'Aquí se mostrará una lista cuando hayas iniciado sesión.',
  notificationsNotLoggedIn: 'Tus notificaciones se mostrarán aquí cuando hayas iniciado sesión.',
  notificationMentionsNotLoggedIn: 'Las notificaciones de tus menciones se mostrarán aquí cuando hayas iniciado sesión.',
  statusNotLoggedIn: 'Aquí se mostrará un hilo de toots cuando hayas iniciado sesión.',
  tagNotLoggedIn: 'Aquí se mostrará una cronología de hashtags cuando hayas iniciado sesión.',
  bubbleTimelineNotLoggedIn: 'Tu cronología de burbujas aparecerá aquí cuando hayas iniciado sesión.',
  bubbleTimelineNotSupported: 'Tu instancia no soporta la cronología de burbujas.',
  accountNotLoggedIn: 'La configuración de la cuenta aparecerá aquí cuando hayas iniciado sesión.',
  filtered: 'Filtrado',
  // Notification subpages
  filters: 'Filtros',
  all: 'Todo',
  mentions: 'Menciones',
  // Follow requests
  approve: 'Aceptar',
  reject: 'Rechazar',
  // Hotkeys
  hotkeys: 'Atajos de teclado',
  global: 'Globales',
  timeline: 'Cronología',
  media: 'Multimedia',
  globalHotkeys: `
    {leftRightChangesFocus, select,
      true {
        <li><kbd>→</kbd> para ir al elemento enfocable siguiente</li>
        <li><kbd>←</kbd> para ir al elemento enfocable anterior</li>
      }
      other {}
    }
    <li>
      <kbd>1</kbd> - <kbd>6</kbd>
      {leftRightChangesFocus, select,
        true {}
        other {o <kbd>←</kbd>/<kbd>→</kbd>}
      }
      para cambiar de columna
    </li>
    <li><kbd>7</kbd> o <kbd>c</kbd> para redactar un nuevo toot</li>
    <li><kbd>s</kbd> o <kbd>/</kbd> para buscar</li>
    <li><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>←</kbd>/<kbd>→</kbd> para mover la pestaña enfocada</li>
    <li><kbd>g</kbd> + <kbd>h</kbd> para ir a inicio</li>
    <li><kbd>g</kbd> + <kbd>n</kbd> para ir a notificaciones</li>
    <li><kbd>g</kbd> + <kbd>l</kbd> para ir a la cronología local</li>
    <li><kbd>g</kbd> + <kbd>b</kbd> para ir a la cronología de burbuja</li>
    <li><kbd>g</kbd> + <kbd>t</kbd> para ir a la cronología federada</li>
    <li><kbd>g</kbd> + <kbd>c</kbd> para ir a la página de comunidad</li>
    <li><kbd>g</kbd> + <kbd>d</kbd> para ir a la página de mensajes directos</li>
    <li><kbd>g</kbd> + <kbd>i</kbd> para ir a la página de instancias</li>
    <li><kbd>h</kbd> o <kbd>?</kbd> para abrir o cerrar el diálogo de ayuda</li>
    <li><kbd>Backspace</kbd> para retroceder, cerrar diálogos</li>
  `,
  timelineHotkeys: `
    <li><kbd>j</kbd> o <kbd>↓</kbd> para activar el toot siguiente</li>
    <li><kbd>k</kbd> o <kbd>↑</kbd> para activar el toot anterior</li>
    <li><kbd>.</kbd> para mostrar más y desplazarse al principio</li>
    <li><kbd>o</kbd> para abrir</li>
    <li><kbd>f</kbd> para marcar como favorito</li>
    <li><kbd>b</kbd> para reenviar</li>
    <li><kbd>r</kbd> para responder</li>
    <li><kbd>e</kbd> para editar tus propias publicaciones</li>
    <li><kbd>q</kbd> para citar una publicación, si es compatible</li>
    <li><kbd>Escape</kbd> para cerrar respuesta</li>
    <li><kbd>a</kbd> para marcador</li>
    <li><kbd>i</kbd> para abrir imágenes, vídeo o audio</li>
    <li><kbd>y</kbd> para mostrar u ocultar multimedia sensible</li>
    <li><kbd>m</kbd> para mencionar al autor</li>
    <li><kbd>p</kbd> para abrir el perfil del autor</li>
    <li><kbd>l</kbd> para abrir el enlace de la publicación en una nueva pestaña</li>
    <li><kbd>x</kbd> para mostrar u ocultar el texto tras una advertencia de contenido</li>
    <li><kbd>z</kbd> para mostrar u ocultar todas las advertencias de contenido en un hilo</li>
    <li><kbd>t</kbd> para traducir una publicación</li>
  `,
  mediaHotkeys: `
    <li><kbd>←</kbd> / <kbd>→</kbd> para ir a siguiente o anterior</li>
  `,
  // Community page, tabs
  tabLabel: `{label} {current, select,
    true {(Actual)}
    other {}
  }`,
  pageTitle: `
    {hasNotifications, select,
      true {({count})}
      other {}
    }
    {name}
    ·
    {showInstanceName, select,
      true {{instanceName}}
      other {{appName}}
    }
  `,
  pinLabel: `{label} {pinnable, select,
    true {
      {pinned, select,
        true {(página fijada)}
        other {(Página no fijada)}
      }
    }
    other {}
  }`,
  pinPage: 'Fijar {label}',
  // Status composition
  composeStatus: 'Redactar toot',
  postStatus: 'Toot!',
  contentWarning: 'Advertencia de contenido',
  dropToUpload: 'Soltar para subir',
  invalidFileType: 'Tipo de fichero no válido',
  composeLabel: '¿En qué estás pensando?',
  autocompleteDescription: 'Cuando haya disponibles resultados de autocompletado, pulsa las flechas arriba o abajo y enter para seleccionar.',
  mediaUploads: 'Subidas multimedia',
  edit: 'Editar',
  delete: 'Borrar',
  description: 'Descripción',
  descriptionLabel: 'Describir para las personas con discapacidad visual (imagen, vídeo) o con discapacidad auditiva (audio, vídeo)',
  markAsSensitive: 'Marcar multimedia como sensible',
  // Polls
  createPoll: 'Crear encuesta',
  removePollChoice: 'Eliminar opción {index}',
  pollChoiceLabel: 'Opción {index}',
  multipleChoice: 'Selección múltiple',
  pollDuration: 'Duración de la encuesta',
  fiveMinutes: '5 minutos',
  thirtyMinutes: '30 minutos',
  oneHour: '1 hora',
  sixHours: '6 horas',
  twelveHours: '12 horas',
  oneDay: '1 día',
  threeDays: '3 días',
  sevenDays: '7 días',
  never: 'Nunca',
  addEmoji: 'Insertar emoji',
  addMedia: 'Añadir multimedia (imágenes, vídeo, audio)',
  addPoll: 'Añadir encuesta',
  removePoll: 'Eliminar encuesta',
  postPrivacyLabel: 'Ajustar privacidad (actualmente {label})',
  addContentWarning: 'Añadir advertencia de contenido',
  removeContentWarning: 'Eliminar advertencia de contenido',
  altLabel: 'Describir para las personas con discapacidad visual',
  extractText: 'Extraer texto de imagen',
  extractingText: 'Extrayendo texto…',
  extractingTextCompletion: 'Extrayendo texto ({percent}% completado)…',
  unableToExtractText: 'No se puede extraer texto.',
  // Account options
  followAccount: 'Seguir a {account}',
  unfollowAccount: 'Dejar de seguir a {account}',
  blockAccount: 'Bloquear a {account}',
  unblockAccount: 'Desbloquear a {account}',
  muteAccount: 'Silenciar a {account}',
  unmuteAccount: 'Dejar de silenciar a Unmute {account}',
  showReblogsFromAccount: 'Mostrar toots reenviados por {account}',
  hideReblogsFromAccount: 'Ocultar toots reenviados por {account}',
  showDomain: 'Dejar de ocultar {domain}',
  hideDomain: 'Ocultar {domain}',
  reportAccount: 'Denunciar a {account}',
  mentionAccount: 'Mencionar a {account}',
  copyLinkToAccount: 'Copiar enlace a cuenta',
  copiedToClipboard: 'Copiado al portapapeles',
  // Media dialog
  navigateMedia: 'Navegar por elementos multimedia',
  showPreviousMedia: 'Mostrar multimedia anterior',
  showNextMedia: 'Mostrar multimedia siguiente',
  enterPinchZoom: 'Modo pinch-zoom',
  exitPinchZoom: 'Salir del modo pinch-zoom',
  showMedia: `Mostrar {index, select,
    1 {primer}
    2 {segundo}
    3 {tercero}
    other {cuarto}
  } multimedia {current, select,
    true {(actual)}
    other {}
  }`,
  previewFocalPoint: 'Previsualizar (punto focal)',
  enterFocalPoint: 'Introducir el punto focal (X, Y) para este multimedia',
  muteNotifications: 'Silenciar también las notificaciones',
  muteAccountConfirm: '¿Silenciar a {account}?',
  mute: 'Silenciar',
  unmute: 'Dejar de silenciar',
  zoomOut: 'Alejar',
  zoomIn: 'Acercar',
  // Reporting
  reportingLabel: 'Estás denunciando a {account} a los moderadores de {instance}.',
  additionalComments: 'Comentarios adicionales',
  forwardDescription: '?Reenviar también a los moderadores de {instance}?',
  forwardLabel: 'Reenviar a {instance}',
  unableToLoadStatuses: 'No se pueden cargar los toots recientes: {error}',
  report: 'Denunciar',
  noContent: '(Sin contenido)',
  noStatuses: 'No hay toots para denunciar',
  // Status options
  unpinFromProfile: 'Dejar de fijar en el perfil',
  pinToProfile: 'Fijar en el perfil',
  muteConversation: 'Silenciar conversación',
  unmuteConversation: 'Dejar de silenciar conversación',
  bookmarkStatus: 'Poner marcador al toot',
  unbookmarkStatus: 'Quitar marcador al toot',
  deleteAndRedraft: 'Borrar y volver a redactar',
  reportStatus: 'Denunciar toot',
  shareStatus: 'Compartir toot',
  copyLinkToStatus: 'Copiar enlace al toot',
  // Account profile
  profileForAccount: 'Perfil para {account}',
  statisticsAndMoreOptions: 'Estadísticas y más opciones',
  statuses: 'Toots',
  follows: 'Siguiendo',
  followers: 'Seguidores',
  moreOptions: 'Más opciones',
  followersLabel: 'Te han seguido {count}',
  followingLabel: 'Has seguido a {count}',
  followLabel: `Seguimiento {requested, select,
    true {(solicitud de seguimiento)}
    other {}
  }`,
  unfollowLabel: `Dejar de seguir {requested, select,
    true {(solicitud de seguimiento)}
    other {}
  }`,
  notify: 'Suscribirse a {account}',
  denotify: 'Cancelar suscripción a {account}',
  subscribedAccount: 'Te has suscrito a la cuenta',
  unsubscribedAccount: 'Has cancelado tu suscripción a la cuenta',
  unblock: 'Desbloquear',
  nameAndFollowing: 'Nombre y seguimientos',
  clickToSeeAvatar: 'Haz clic para ver el avatar',
  opensInNewWindow: '{label} (Se abre en nueva ventana)',
  blocked: 'Bloqueado',
  domainHidden: 'Dominio oculto',
  muted: 'Silenciado',
  followsYou: 'Te está siguiendo',
  avatarForAccount: 'Avatar para {account}',
  fields: 'Campos',
  accountHasMoved: '{account} se ha trasladado:',
  profilePageForAccount: 'Página de perfil para {account}',
  verified: 'Verified',
  // About page
  about: 'Acerca de',
  aboutApp: 'Acerca de Zocial',
  aboutAppDescription: `
  <p>
    Zocial es software <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial">de código abierto</a> y un fork de <a rel="noopener" target="_blank" href="https://github.com/enafore/enafore">Enafore</a>, creado por <a rel="noopener" target="_blank" href="https://social.ztfr.eu/@dome">Dome</a>.
  </p>

  <h2 id="privacy-policy">Política de privacidad</h2>

  <p>
    Zocial no almacena ninguna información personal en sus servidores, incluyendo, entre otros, nombres, direcciones de correo electrónico, direcciones IP, publicaciones y fotos.
  </p>

  <p>
    Zocial es un sitio estático que puede alojarse en cualquier lugar (por ejemplo, GitHub Pages). Se ofrece como una <a rel="noopener" target="_blank" href="https://hub.docker.com/r/domoel/zocial">imagen de Docker</a> y puede desplegarse con un servidor web nginx. Todos los datos se almacenan localmente en tu navegador y solo se comparten con la(s) instancia(s) del fediverso a la(s) que te conectas.
  </p>

  <h2>Traducciones</h2>

  <p>
    La traducción de publicaciones funciona con <a rel="noopener" target="_blank" href="https://libretranslate.com">LibreTranslate</a> — un motor de traducción de código abierto sin dependencia de Google. Las solicitudes se enrutan a través del servidor, por lo que ningún servicio de traducción es contactado directamente desde tu navegador. El autoalojamiento está disponible mediante la variable de entorno <code>TRANSLATE_API</code>.
  </p>

  <h2>Uso de IA</h2>

  <p>
    Este proyecto cuenta con apoyo de IA. No obstante, su desarrollo sigue una rigurosa <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Architecture.md">filosofía de diseño</a> y estrictos principios de programación, y se pone gran cuidado al implementar nuevas funciones. El código se revisa con regularidad.
  </p>

  <h2>Créditos</h2>

  <p>
    Iconos proporcionados por <a rel="noopener" target="_blank" href="http://fontawesome.io/">Font Awesome</a>.
  </p>

  <h2>Licencia</h2>

  <p>
    Zocial se distribuye bajo la <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/LICENSE">Licencia Pública General Affero de GNU</a>. Powered by <a rel="noopener" target="_blank" href="https://ztfr.eu/">Zeitfresser</a>
  </p>

  <h2 id="donations">Donaciones</h2>

  <p>
    Zocial es un proyecto sin ánimo de lucro y de uso gratuito. Las donaciones son totalmente opcionales: simplemente ayudan a cubrir los gastos de funcionamiento de la instancia pública (dominio y alojamiento).
  </p>

  <p>
    Si quieres apoyarlo: <a rel="noopener" target="_blank" href="https://www.paypal.com/donate/?hosted_button_id=QMWFH4FDXN66C">Donar con PayPal</a>.
  </p>

  <h2>Soporte y desarrollo</h2>

  <p>
    Consulta la <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/User-Guide.md">guía de usuario</a> para el uso general y la <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Admin-Guide.md">guía de administración</a> si tu instancia tiene problemas de conexión. Si quieres entender la arquitectura subyacente y las decisiones de diseño detrás de Zocial, consulta el <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Architecture.md">Manual de arquitectura</a>.
  </p>

  <p>
    Para más soporte o para participar en el desarrollo, únete a la <a rel="noopener" target="_blank" href="https://ztfr.eu/matrix">Comunidad Matrix de Zeitfresser</a> o al <a rel="noopener" target="_blank" href="https://look.ztfr.eu/#/#support:ztfr.eu">Development &amp; Support Channel</a>.
  </p>

  <h2>Versión</h2>

  <p>
    Estás usando la versión <code class="zocial-version"></code> de Zocial.
  </p>`,
  // Settings
  settings: 'Opciones de configuración',
  general: 'General',
  generalSettings: 'Opciones generales',
  generalSettingsLoginRequired: 'Las opciones generales solo están disponibles cuando has iniciado sesión.',
  showSensitive: 'Mostrar multimedia sensible por defecto',
  showAllSpoilers: 'Expandir advertencias de contenido por defecto',
  showPlain: 'Mostrar un color gris liso para multimedia sensible',
  allSensitive: 'Tratar todo multimedia como sensible',
  largeMedia: 'Mostrar imágenes y vídeos grandes incrustados',
  autoplayGifs: 'Reproducir automáticamente GIFs animados',
  hideCards: 'Ocultar paneles de previsualización de enlaces',
  underlineLinks: 'Subrayar enlaces en toots y perfiles',
  accessibility: 'Accesibilidad',
  reduceMotion: 'Reducir movimiento en animaciones de la interfaz',
  disableTappable: 'Deshabilitar área para tocar en todo el toot',
  removeEmoji: 'Eliminar emoji de nombres de usuario',
  shortAria: 'Usar etiquetas ARIA cortas para artículos',
  announceCardDescriptionsPre: 'Anunciar descripciones de ',
  announceCardDescriptionsText: 'previsualización de enlaces',
  announceCardDescriptionsDescription: 'El título de una tarjeta de previsualización siempre se incluye. Activa esto para incluir también el texto de descripción.',
  announceCardDescriptionsPost: '',
  theme: 'Diseño visual',
  themeForInstance: 'Diseño visual para {instance}',
  disableCustomScrollbars: 'Deshabilitar barras deslizantes personalizadas',
  bottomNav: 'Situar la barra de navegación al final de la pantalla',
  centerNav: 'Centrar la barra de navegación',
  preferences: 'Preferencias',
  hotkeySettings: 'Opciones para atajos de teclado',
  disableHotkeys: 'Deshabilitar todos los atajos de teclado',
  leftRightArrows: 'Las flechas izquierda/derecha cambian el foco en vez de columnas/multimedia',
  guide: 'Guía',
  reload: 'Recargar',
  disableFollowRequestCount: 'Ocultar recuento de solicitudes de seguimiento',
  hideLongPosts: 'Colapsar publicaciones largas sin advertencia de contenido',
  // Wellness settings
  wellness: 'Bienestar',
  wellnessDescription: `Las opciones para el bienestar están diseñadas para reducir los aspectos que inducen adicción o ansiedad en las redes sociales.
    Elige cualquier opción que vaya bien para ti.`,
  enableAll: 'Habilitar todos',
  metrics: 'Métricas',
  hideFollowerCount: 'Ocultar recuento de seguidores (hasta 10)',
  hideReblogCount: 'Ocultar recuento de reenvíos',
  hideFavoriteCount: 'Ocultar recuento de favoritos',
  hideUnread: 'Ocultar recuento de notificaciones sin leer (es decir, el punto rojo)',
  osNotificationsHeading: 'Notificaciones Push',
  osNotificationsDescription: 'Recibe notificaciones en este dispositivo, incluso cuando Zocial está cerrado.',
  notifyOnThisDevice: 'Activar notificaciones push del SO en este dispositivo',
  notifyOnThisDevicePre: 'Activar',
  notifyOnThisDeviceTrigger: 'notificaciones push del SO',
  notifyOnThisDevicePost: 'en este dispositivo',
  pushOneAccountPerDevice: 'Las notificaciones push del SO solo se permiten para una cuenta por dispositivo.',
  pushActiveForOtherAccount: 'Actualmente activo para {account}.',
  pushSwitchTitle: '¿Mover las notificaciones push?',
  pushSwitchText: 'Las notificaciones push del SO están limitadas a una cuenta por dispositivo. ¿Activarlas para {to} y desactivarlas para {from}?',
  pushSwitchConfirm: 'Mover',
  pushMovedToast: 'Notificaciones push movidas a {to}: {from} ya no notificará en este dispositivo.',
  deviceNotificationsForegroundOnly: 'Este servidor no soporta push en segundo plano.',
  inAppNotificationsHeading: 'Notificaciones en la aplicación',
  inAppNotificationsDescription: 'Qué actividad aparece en la pestaña de notificaciones.',
  notificationSoundHeading: 'Sonidos de notificación',
  notificationSoundDescription: 'Reproducir un sonido cuando llega una nueva notificación.',
  notificationSounds: 'Sonidos de notificación',
  osNotificationsPromptTitle: '¿Activar notificaciones en este dispositivo?',
  osNotificationsPromptText: 'Recibe notificaciones de escritorio o push. Puedes cambiar esto en cualquier momento.',
  enableNotifications: 'Activar',
  notNow: 'Ahora no',
  enableDesktopNotifications: 'Activar notificaciones de escritorio',
  desktopNotificationsNotSupported: 'Tu navegador no soporta notificaciones de escritorio.',
  desktopNotificationsBlocked: 'Las notificaciones están bloqueadas.',
  desktopNotificationTitle: 'Zocial',
  desktopNotificationBody: '{count, plural, one {una nueva notificación} other {{count} nuevas notificaciones}}',
  // The quality that makes something seem important or interesting because it seems to be happening now
  immediacy: 'Inmediatez',
  showAbsoluteTimestamps: 'Mostrar marcas de tiempo absolutas (p.ej., "3 de marzo") en vez de marcas de tiempo relativas (p. ej., "hace 5 minutos")',
  ui: 'Interfaz',
  language: 'Idioma',
  interfaceLanguage: 'Idioma de la interfaz',
  grayscaleMode: 'Modo escala de grises',
  wellnessFooter: `Estas opciones están parcialmente basadas en pautas del
    <a rel="noopener" target="_blank" href="https://humanetech.com">Center for Humane Technology</a>.`,
  // This is a link: "You can filter or disable notifications in the _instance settings_"
  filterNotificationsPre: 'Puedes filtrar o deshabilitar notificaciones en',
  filterNotificationsText: 'opciones para instancia',
  filterNotificationsPost: '',
  // Custom tooltips, like "Disable _infinite scroll_", where you can click _infinite scroll_
  // to see a description. It's hard to properly internationalize, so we just break up the strings.
  disableInfiniteScrollPre: 'Deshabilitar',
  disableInfiniteScrollText: 'desplazamiento infinito',
  disableInfiniteScrollDescription: `Cuando el desplazamiento infinito esté deshabilitado, los nuevos toots no se mostrarán automáticamente al final o al principio de la cronología. En vez de esto, habrá botones que te permitirán
             cargar más contenido a demanda.`,
  disableInfiniteScrollPost: '',
  // Instance settings
  loggedInAs: 'Iniciaste sesión como',
  homeTimelineFilters: 'Filtros para la cronología Inicio',
  notificationFilters: 'Filtros para notificaciones',
  followedHashtags: 'Hashtags seguidos',
  noFollowedHashtags: 'No sigues ningún hashtag.',
  addHashtag: 'Seguir hashtag',
  pushNotifications: 'Notificaciones Push',
  // Add instance page
  storageError: `Parece que Zocial no puede almacenar datos localmente. ¿Está tu navegador en modo privado
          o bloqueando las cookies? Zocial almacena todos los datos localmente, y requiere LocalStorage e
          IndexedDB para funcionar correctamente.`,
  javaScriptError: 'Debes habilitar JavaScript para iniciar sesión.',
  enterInstanceName: 'Introducir nombre de instancia',
  instanceColon: 'Instancia:',
  // Custom tooltip, concatenated together
  getAnInstancePre: '¿No tienes una',
  getAnInstanceText: 'instancia',
  getAnInstanceDescription: 'Una instancia es tu servidor de inicio de Mastodon, por ejemplo, mastodon.social o cybre.space.',
  getAnInstancePost: '?',
  joinMastodon: '¡Unirse a Mastodon!',
  instancesYouveLoggedInTo: 'Instancias en las que has iniciado sesión:',
  addAnotherInstance: 'Añadir otra instancia',
  youreNotLoggedIn: 'No has iniciado sesión en ninguna instancia.',
  currentInstanceLabel: `{instance} {current, select,
    true {(instancia actual)}
    other {}
  }`,
  // Link text
  logInToAnInstancePre: '',
  logInToAnInstanceText: 'Inicia sesión en una instancia',
  logInToAnInstancePost: 'para empezar a usar Zocial.',
  // Another custom tooltip
  showRingPre: 'Mostrar siempre',
  showRingText: 'anillo del foco',
  showRingDescription: 'El anillo del foco es el contorno que muestra el elemento que actualmente tiene el foco. Por defecto solo se muestra cuando se usa el teclado (no el ratón o un dispositivo táctil), pero puedes elegir mostrarlo siempre.',
  showRingPost: '',
  instances: 'Instancias',
  addInstance: 'Añadir instancia',
  homeTimelineFilterSettings: 'Opciones para filtros de la cronología Inicio',
  showReblogs: 'Mostrar reenvíos',
  showReplies: 'Mostrar respuestas',
  switchOrLogOut: 'Seleccionar o cerrar sesión en esta instancia',
  switchTo: 'Seleccionar esta instancia',
  switchToInstance: 'Seleccionar instancia',
  switchToNameOfInstance: 'Seleccionar {instance}',
  logOut: 'Cerrar sesión',
  logOutOfInstanceConfirm: '¿Cerrar sesión en {instance}?',
  notificationFilterSettings: 'Opciones para filtros de notificaciones',
  // Push notifications
  browserDoesNotSupportPush: 'Tu navegador no admite notificaciones Push.',
  deniedPush: 'Has denegado el permiso para mostrar notificaciones.',
  pushSettings: 'Opciones para notificaciones Push',
  newFollowers: 'Nuevos seguidores',
  reblogs: 'Reenvíos',
  pollResults: 'Resultados de encuesta',
  subscriptions: 'Suscripción a toots',
  needToReauthenticate: 'Tienes que volver a autenticarte para habilitar las notificaciones Push. ¿Cerrr sesión en {instance}?',
  failedToUpdatePush: 'Se ha producido un fallo al actualizar las opciones para notificaciones Push: {error}',
  // Themes
  chooseTheme: 'Elegir un diseño visual',
  darkBackground: 'Fondo oscuro',
  lightBackground: 'Fondo claro',
  themeLabel: `{label} {default, select,
    true {(por defecto)}
    other {}
  }`,
  animatedImage: 'Imagen animada: {description}',
  showImage: `Mostrar {animated, select,
    true {animated}
    other {}
  } imagen: {description}`,
  playVideoOrAudio: `Reproducir {audio, select,
    true {audio}
    other {vídeo}
  }: {description}`,
  accountFollowedYou: '{name} te siguió, {account}',
  accountSignedUp: '{name} inició sesión, {account}',
  accountRequestedFollow: '{name} solicitó seguirte, {account}',
  accountReported: '{name} creó una denuncia, {account}',
  reblogCountsHidden: 'Recuento de reenvíos oculto',
  favoriteCountsHidden: 'Recuento de favoritos oculto',
  rebloggedTimes: `Reenviado {count, plural,
    one {1 vez}
    other {{count} veces}
  }`,
  favoritedTimes: `Marcado como favorito {count, plural,
    one {1 vez}
    other {{count} veces}
  }`,
  pinnedStatus: 'Toot fijado',
  rebloggedYou: 'reenvió tu toot',
  quotedYou: 'citó tu toot',
  quotedPostEdited: 'editó un toot que citaste',
  severedRelationships: 'Se eliminaron las conexiones con {name}',
  moderationWarning: 'Recibiste una advertencia de la moderación',
  annualReportReady: 'Tu #Wrapstodon {year} está listo',
  favoritedYou: 'marcó como favorito tu toot',
  followedYou: 'te siguió',
  edited: 'editó su toot',
  requestedFollow: 'solicitó seguirte',
  reported: 'creó una denuncia',
  signedUp: 'sesión iniciada',
  posted: 'publicado',
  pollYouCreatedEnded: 'Una encuesta que creaste ha finalizado',
  pollYouVotedEnded: 'Una encuesta en la que votaste ha finalizado',
  reblogged: 'reenviado',
  startedThread: 'comenzó un hilo',
  favorited: 'marcado como favorito',
  unreblogged: 'no reenviado',
  unfavorited: 'no marcado como favorito',
  showSensitiveMedia: 'Mostrar multimedia sensible',
  hideSensitiveMedia: 'Ocultar multimedia sensible',
  clickToShowSensitive: 'Contenido sensible. Haz clic para mostrar.',
  longPost: 'Publicación larga',
  longPostLengthLabel: 'Umbral de colapso (caracteres)',
  // Accessible status labels
  accountRebloggedYou: '{account} reenvió tu toot',
  accountFavoritedYou: '{account} marcó como favorito tu toot',
  accountEdited: '{account} editó su toot',
  contentWarningContent: 'Advertencia de contenido: {spoiler}',
  hasMedia: 'tiene multimedia',
  hasPoll: 'tiene encuesta',
  shortStatusLabel: '{privacy} toot de {account}',
  // Privacy types
  public: 'Público',
  unlisted: 'No listado',
  followersOnly: 'Solo seguidores',
  direct: 'Directo',
  // Themes
  themeRoyal: 'Light',
  themeScarlet: 'Escarlata',
  themeSeafoam: 'Espuma de mar',
  themeHotpants: 'Hotpants',
  themeOaken: 'Roble',
  themeMajesty: 'Majesty',
  themeGecko: 'Gecko',
  themeGrayscale: 'Escala de grises',
  themeZocial: 'Zocial',
  themeOzark: 'Ozark',
  themeCobalt: 'Cobalto',
  themeSorcery: 'Sorcery',
  themePunk: 'Punk',
  themeRiot: 'Riot',
  themeHacker: 'Hacker',
  themeMastodon: 'Mastodon',
  themePitchBlack: 'Tono negro',
  themeDarkGrayscale: 'Escala de gris oscuro',
  // Polls
  voteOnPoll: 'Votar en encuesta',
  pollChoices: 'Opciones de la encuesta',
  vote: 'Votar',
  pollDetails: 'Detalles de la encuesta',
  refresh: 'Actualizar',
  expires: 'Finaliza',
  expired: 'Finalizada',
  voteCount: `{count, plural,
    one {1 voto}
    other {{count} votos}
  }`,
  // Status interactions
  clickToShowThread: '{time} - haz clic para mostrar el hilo',
  showMore: 'Mostrar más',
  showLess: 'Mostrar menos',
  closeReply: 'Cerrar respuesta',
  cannotReblogFollowersOnly: 'No se puede reenviar porque es solo para seguidores',
  cannotReblogDirectMessage: 'No se puede reenviar porque es un mensaje directo',
  reblog: 'Reenviar',
  reply: 'Responder',
  replyTo: 'En respuesta a',
  replyToLower: 'en respuesta a',
  replyToThread: 'Responder al hilo',
  favorite: 'Favorito',
  unfavorite: 'No favorito',
  // timeline
  loadingMore: 'Cargando más…',
  loadMore: 'Cargar más',
  showCountMore: 'Mostrar {count} más',
  nothingToShow: 'Nada para mostrar.',
  couldNotLoadAccounts: 'No se pudo cargar esta lista. Comprueba tu conexión e inténtalo de nuevo.',
  accountListUnavailable: 'Esta lista no está disponible aquí: la cuenta puede mantenerla privada, o tu servidor no la tiene.',
  accountListPartial: 'Mostrando {shown} de {total}: tu servidor no proporciona el resto.',
  // status thread page
  statusThreadPage: 'Página de hilo de toots',
  status: 'Toot',
  // toast messages
  blockedAccount: 'Cuenta bloqueada',
  unblockedAccount: 'Cuenta desbloqueada',
  unableToBlock: 'No se puede bloquear la cuenta: {error}',
  unableToUnblock: 'No se puede desbloquear la cuenta: {error}',
  bookmarkedStatus: 'Toot con marcador',
  unbookmarkedStatus: 'Toot sin marcador',
  unableToBookmark: 'No se puede poner marcador: {error}',
  unableToUnbookmark: 'No se puede quitar marcador: {error}',
  cannotPostOffline: 'No puedes publicar mientras estás sin conexión',
  cannotPostEmpty: 'Escribe algo o añade contenido multimedia antes de publicar.',
  pollNeedsTwoOptions: 'Dale a tu encuesta al menos dos opciones no vacías.',
  unableToPost: 'No se puede publicar el toot: {error}',
  statusDeleted: 'Toot borrado',
  unableToDelete: 'No se puede borrar el toot: {error}',
  unableToEdit: 'No se puede editar el toot: {error}',
  cannotFavoriteOffline: 'No puedes marcar como favorito mientras estás sin conexión',
  cannotUnfavoriteOffline: 'No puedes quitar marca de favorito mientras estás sin conexión',
  // Custom emoji reactions
  cannotReactWithRemoteEmoji: 'Tu instancia no permite reaccionar con emojis personalizados remotos',
  tooManyMediaAttachments: 'Solo se permiten {max} archivos multimedia',
  // Instance login errors
  alreadyLoggedInTo: 'Ya has iniciado sesión en {instance}',
  areYouOffline: '¿Estás sin conexión?',
  invalidOauthState: 'Estado de OAuth no válido: vuelve a iniciar sesión',
  failedToConnectToInstance: '{error}. No se pudo conectar con la instancia.',
  instanceGenericError: '¿Es una instancia válida? ¿Hay una extensión del navegador bloqueando la solicitud? ¿Estás en modo de navegación privada? Si crees que es un problema de tu instancia, envía <a href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Admin-Guide.md" target="_blank" rel="noopener">este enlace</a> a la administración de tu instancia.',
  unableToFavorite: 'No se puede marcar como favorito: {error}',
  unableToUnfavorite: 'No se puede quitar marca de favorito: {error}',
  followedAccount: 'Cuenta seguida',
  unfollowedAccount: 'Cuenta no seguida',
  removeFollowerAccount: 'Quitar a {account} de tus seguidores',
  removeFollowerTitle: '¿Quitar seguidor?',
  removeFollowerText: '¿Quitar a {account} de tus seguidores? No puedes deshacer esto tú mismo: solo esa persona puede volver a seguirte.',
  removeFollowerConfirm: 'Quitar',
  removedFollower: 'Quitado de tus seguidores',
  removeFromFollowersNotSupported: 'Este servidor no permite quitar seguidores.',
  unableToFollow: 'No se puede seguir a la cuenta: {error}',
  unableToUnfollow: 'No se puede dejar de seguir a la cuenta: {error}',
  accessTokenRevoked: 'El token de acceso fue anulado, se cerró sesión en {instance}',
  loggedOutOfInstance: 'Se cerró sesión en {instance}',
  failedToUploadMedia: 'Falló la subida del multimedia: {error}',
  waitForMediaUpload: 'Espera a que termine la subida del archivo multimedia',
  discardDraftConfirm: 'Tienes una publicación sin terminar que aún no se ha enviado. ¿Descartarla?',
  discardDraft: 'Descartar',
  mutedAccount: 'Cuenta silenciada',
  unmutedAccount: 'Cuenta no silenciada',
  unableToMute: 'No se puede silenciar la cuenta: {error}',
  unableToUnmute: 'No se puede dejar de silenciar la cuenta: {error}',
  mutedConversation: 'Conversación silenciada',
  unmutedConversation: 'Conversación no silenciada',
  unableToMuteConversation: 'No se puede silenciar la conversación: {error}',
  unableToUnmuteConversation: 'No se puede dejar de silenciar la conversación: {error}',
  unpinnedStatus: 'Toot no fijado',
  unableToPinStatus: 'No se puede fijar el toot: {error}',
  unableToUnpinStatus: 'No se puede dejar de fijar el toot: {error}',
  unableToRefreshPoll: 'No se puede actualizar la encuesta: {error}',
  unableToVoteInPoll: 'No se puede votar en la encuesta: {error}',
  cannotReblogOffline: 'No puedes reenviar mientras estás sin conexión.',
  cannotUnreblogOffline: 'No puedes deshacer reenvíos mientras estás sin conexión.',
  failedToReblog: 'Fallo al reenviar: {error}',
  failedToUnreblog: 'Fallo al deshacer reenvío: {error}',
  submittedReport: 'Denuncia enviada',
  failedToReport: 'Fallo al enviar denuncia: {error}',
  approvedFollowRequest: 'Solicitud de seguimiento aceptada',
  rejectedFollowRequest: 'Solicitud de seguimiento rechazada',
  unableToApproveFollowRequest: 'No se puede aceptar la solicitud de seguimiento: {error}',
  unableToRejectFollowRequest: 'No se puede rechazar la solicitud de seguimiento: {error}',
  searchError: 'Error durante la búsqueda: {error}',
  hidDomain: 'Dominio oculto',
  unhidDomain: 'Dominio no oculto',
  unableToHideDomain: 'No se puede ocultar el dominio: {error}',
  unableToUnhideDomain: 'No se puede dejar de ocultar el dominio: {error}',
  showingReblogs: 'Mostrando reenvíos',
  hidingReblogs: 'Ocultando reenvíos',
  unableToShowReblogs: 'No se puede mostrar los reenvíos: {error}',
  unableToHideReblogs: 'No se puede ocultar los reenvíos: {error}',
  unableToShare: 'No se puede compartir: {error}',
  unableToSubscribe: 'Imposible suscribirse: {error}',
  unableToUnsubscribe: 'Imposible dejar de suscribirse: {error}',
  showingOfflineContent: 'La petición a internet falló. Mostrando contenido sin conexión.',
  youAreOffline: 'Parece que estás sin conexión. Puedes leer contenido incluso sin conexión.',
  // Snackbar UI
  updateAvailable: 'Actualización de la aplicación disponible.',
  // Word/phrase filters
  wordFilters: 'Filtros de palabras',
  noFilters: 'No tienes ningún filtro de palabras.',
  wordOrPhrase: 'Palabra o frase',
  contexts: 'Contextos',
  addFilter: 'Añadir filtro',
  editFilter: 'Editar filtro',
  filterHome: 'Inicio y listas',
  filterNotifications: 'Notificaciones',
  filterPublic: 'Cronologías públicas',
  filterThread: 'Conversaciones',
  filterAccount: 'Perfiles',
  filterUnknown: 'Desconocido',
  expireAfter: 'Expira al cabo de',
  whereToFilter: 'Dónde filtrar',
  irreversible: 'Irreversible',
  wholeWord: 'Palabra completa',
  save: 'Guardar',
  updatedFilter: 'Filtro actualizado',
  createdFilter: 'Filtro creado',
  failedToModifyFilter: 'Fallo al modificar el filtro: {error}',
  deletedFilter: 'Filtro borrado',
  required: 'Requerido',
  // Dialogs
  profileOptions: 'Opciones de perfil',
  copyLink: 'Copiar enlace',
  emoji: 'Emoji',
  editMedia: 'Editar multimedia',
  shortcutHelp: 'Ayuda sobre atajos de teclado',
  statusOptions: 'Opciones de estado',
  confirm: 'Confirmar',
  closeDialog: 'Cerrar diálogo',
  postPrivacy: 'Privacidad del post',
  homeOnInstance: 'Inicio en {instance}',
  statusesTimelineOnInstance: 'Estados: {timeline} cronología en {instance}',
  statusesHashtag: 'Estados: #{hashtag} hashtag',
  statusesThread: 'Estados: hilo',
  statusesAccountTimeline: 'Estado: cronología de cuenta',
  statusesList: 'Estado: lista',
  notificationsOnInstance: 'Notificaciones en {instance}',
  // Details
  statusEdited: 'Editado',

  // --- Completado 2026-06-15: claves antes ausentes (recurrían al inglés) ---
  // Encuestas / programación
  youVotedFor: 'Votaste por',
  fourteenDays: '14 días',
  thirtyDays: '30 días',
  oneYear: '1 año',
  schedulePost: 'Programar publicación',
  removeSchedule: 'Quitar programación',
  scheduleSet: 'Programar',
  scheduleDateTimeLabel: 'Enviar el',
  scheduleTooSoon: 'La hora programada debe ser al menos 5 minutos a partir de ahora',
  scheduledStatusCreated: 'Publicación programada',
  scheduledPosts: 'Publicaciones programadas',
  noScheduledPosts: 'No hay publicaciones programadas',
  cancelScheduledPost: 'Cancelar',
  rescheduleLabel: 'Reprogramar',
  scheduledPostCancelled: 'Publicación programada cancelada',
  scheduledPostRescheduled: 'Reprogramada',
  // Listas / backfill
  backfill: 'Cargar publicaciones faltantes',
  createList: 'Crear lista',
  unableToCreateList: 'No se pudo crear la lista: {error}',
  listTitle: 'Título de la lista',
  manageLists: 'Gestionar listas',
  listMembers: 'Miembros',
  tabReordered: '{label} — posición {position} de {total}',
  tabReorderHint: 'Reordenar con Alt + Mayús + teclas de flecha',
  rename: 'Renombrar',
  listExclusive: 'Mostrar las publicaciones solo en esta lista',
  listExclusiveHelp: 'Los miembros de esta lista no aparecerán en tu línea de inicio.',
  listExclusiveNotSupported: 'Este servidor no admite listas exclusivas.',
  deleteListTitle: '¿Eliminar «{title}»?',
  deleteListConfirm: 'Esto elimina la lista «{title}». Las cuentas que contiene no se ven afectadas; si era exclusiva, sus publicaciones vuelven a tu línea de inicio.',
  deletedList: 'Lista eliminada.',
  unableToRenameList: 'No se pudo renombrar la lista: {error}',
  unableToUpdateList: 'No se pudo actualizar la lista: {error}',
  unableToDeleteList: 'No se pudo eliminar la lista: {error}',
  manageInLists: 'Gestionar pertenencia a listas',
  listMembership: 'Pertenencia a listas de {account}',
  noListsYet: 'Aún no hay listas',
  errorInListMembership: 'Error al actualizar la pertenencia a la lista',
  listMembershipNotSupported: 'No compatible con este servidor',
  // Traducción
  translateStatus: 'Traducir publicación',
  translated: `Publicación traducida de {from}{detected, select,
    true { - Detectado}
    other {}
  }`,
  translation: 'Traducción',
  translationTargetLanguage: 'Idioma de traducción',
  translationBrowserDefault: 'Predeterminado del navegador',
  translationLanguageUnavailable: 'Lista de idiomas no disponible — el idioma de traducción sigue el predeterminado del navegador',
  translateError: 'Hubo un error al traducir esta publicación',
  translateRateLimit: 'Has alcanzado el límite de traducciones',
  translateUnsupportedLanguage: 'Este idioma no es compatible actualmente',
  alreadyInTargetLanguage: 'La publicación ya está en tu idioma',
  translating: 'Traduciendo...',
  hideTranslation: 'Ocultar traducción',
  // Acciones de publicación
  reactToStatus: 'Reaccionar a la publicación',
  quoteStatus: 'Citar publicación',
  joined: 'Se unió',
  // Estadísticas de perfil
  postingStatsSummary: 'Últimas {posts} en {duration}',
  postingStatsPosts: '{total, plural, one {# publicación} other {# publicaciones}}',
  postingStatsDays: '{days, plural, one {# día} other {# días}}',
  postingStatsYears: '{years, plural, one {# año} other {# años}}',
  postingStatsOriginal: 'Originales',
  postingStatsReplies: 'Respuestas',
  postingStatsBoosts: 'Impulsos',
  postingStatsOriginalTitle: '{count, plural, one {# publicación original} other {# publicaciones originales}} ({percent})',
  postingStatsRepliesTitle: '{count, plural, one {# respuesta} other {# respuestas}} ({percent})',
  postingStatsBoostsTitle: '{count, plural, one {# impulso} other {# impulsos}} ({percent})',
  // Navegación / follow
  scrollToTopOfConversation: 'Desplazarse al inicio de la conversación',
  scrollToTop: 'Desplazarse arriba',
  unrequestLabel: 'Cancelar solicitud',
  unfollowingLabel: 'Dejando de seguir...',
  unblockingLabel: 'Desbloqueando...',
  unrequestingLabel: 'Cancelando...',
  requestingLabel: 'Solicitando...',
  locked: 'Esta cuenta es privada. El propietario revisa manualmente quién puede seguirla.',
  // Registros
  logs: 'Registros',
  showAllLogs: 'Mostrar todos los registros (depuración e info)',
  showAllLogsHint: 'De forma predeterminada solo se muestran advertencias y errores. Actívalo para incluir también los registros de depuración e información.',
  copyLogs: 'Copiar registros',
  logsCopied: 'Registros copiados al portapapeles',
  logsCopyFailed: 'No se pudieron copiar los registros',
  clearLogs: 'Borrar registros',
  clearLogsConfirm: '¿Borrar todos los registros? Esto no se puede deshacer.',
  logsCleared: 'Registros borrados',
  // Ajustes
  enableThreadPolling: 'Mostrar el botón de actualización automática en los hilos',
  defaultUnlistedReplies: 'Responder con visibilidad no listada de forma predeterminada',
  defaultLocalOnly: 'Publicar solo en la cronología local de forma predeterminada',
  enableQuotePost: 'Mostrar la opción Impulsar/Citar al impulsar',
  boostOrQuote: 'Impulsar o citar',
  localOnlyUnsupported: 'Tu instancia no admite publicaciones solo locales',
  // Editar perfil
  editProfile: 'Editar perfil',
  editProfileDisplayName: 'Nombre visible',
  editProfileBio: 'Biografía',
  editProfileFields: 'Metadatos del perfil',
  editProfileFieldName: 'Etiqueta',
  editProfileFieldValue: 'Contenido',
  editProfileChangeAvatar: 'Cambiar avatar',
  editProfileChangeHeader: 'Cambiar cabecera',
  editProfileSave: 'Guardar',
  editProfileSaving: 'Guardando…',
  profileUpdated: 'Perfil actualizado',
  profileUpdateFailed: 'No se pudo actualizar el perfil: {error}',
  threadPollingStart: 'Actualizar respuestas automáticamente (cada 30 s)',
  threadPollingStop: 'Detener actualización automática',
  hideReplyCount: 'Ocultar el número de respuestas',
  disableNotificationSound: 'Desactivar los sonidos de notificación',
  composer: 'Redacción',
  filterNotificationsTextSingle: 'ajustes de la cuenta',
  unhandledNotification: 'Tipo de notificación no gestionado {type}',
  // Cabecera de publicación / reacciones
  moved: 'se mudó a',
  bite: 'te mordió',
  reactionCountsHidden: 'Número de reacciones oculto',
  reactedTimes: `Reaccionó {count, plural,
    one {1 vez}
    other {{count} veces}
  }`,
  reacted: 'reaccionó con un emoji',
  reactedWith: 'reaccionó con',
  boostsAction: 'impulsó',
  repliesTo: 'en respuesta a',
  rebloggedByAccount: '{account} impulsó {original}',
  // Themes (nombres propios, sin traducir como los demás)
  themeTangerine: 'Tangerine',
  themeEmber: 'Ember',
  themeCohostLight: 'Cohost Light',
  // Filtros de palabras / varios
  addWordFilter: 'Añadir filtro de palabras',
  dropFiltersNotSupported: 'Este servidor no admite filtros irreversibles (de descarte). Deja «Irreversible» sin marcar para ocultar las publicaciones coincidentes tras una advertencia.',
  copy: 'Copiar',
  localOnly: 'Solo local',
  contentType: 'Tipo de contenido',
  contentTypeLabel: 'Cambiar el tipo de contenido (actualmente {label})',
  // Cabecera de redacción (editar/responder/citar) + opción de encuesta
  editing: 'Editando',
  replyingTo: 'En respuesta a',
  quoting: 'Citando',
  aPost: 'una publicación',
  aPostBy: 'una publicación de {handle}',
  dontEdit: 'No editar',
  dontReply: 'No responder',
  dontQuote: 'No citar',
  addPollChoice: 'Añadir opción',
  postsAndReplies: 'Publicaciones y respuestas'
}
